export const THUMB_HASH = 'YucNI4gJdol3mGiYCmeGgGY';
export const BLUR_HASH = 'LEI5Je.400D7MyAEPU}t5RjG?Ho}';

export const MAX_SIZE = 10 * 1024 * 1024; // 10MB
export const ACCEPTED_MIME_TYPES = new Set([
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/webp',
  'image/tiff'
]);
